import { __assign, __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { dataFieldNamingHandler, exceptionHandler } from '../../../base/decorators';
import { INetworkRequestService } from '../../../base/request/network-request.interface';
import { getFormDataWithParams } from '../../../base/utils';
import { ACCOUNT_TYPE } from '@tencent/ark-utils/lib/base/types';
import { COMMON_COOKIES_KEYS, getCookie, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
import { addURLParameters } from '@tencent/ark-utils/lib/url';
import { ACCOUNT_USER_BIND, ACCOUNT_USER_UNBIND, BINDING_QQ_ACCOUNT_INFO, DISK_LOGOUT, DOCS_LOGOUT, LOGIN_ACCOUNT_INFO, LOGOUT, POLLING, USER_CERTIFICATION_CHECK, USER_INFO_CGI, WXQRCODE, } from './cgi-path';
var AccountRepository = /** @class */ (function () {
    function AccountRepository(networkRequestService) {
        this.networkRequestService = networkRequestService;
    }
    AccountRepository.prototype.logout = function (u) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = addURLParameters(LOGOUT, __assign({ xrsf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)) }, (u && { u: u })));
                return [2 /*return*/, this.networkRequestService.instance.get(url)];
            });
        });
    };
    AccountRepository.prototype.wecomLogoutForBDomain = function (weSid) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = addURLParameters(DISK_LOGOUT, {
                    xrsf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                    sid: weSid,
                });
                return [2 /*return*/, this.networkRequestService.instance.get(url)];
            });
        });
    };
    AccountRepository.prototype.wecomLogoutForCDomain = function (vid) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = addURLParameters(DOCS_LOGOUT, {
                    xrsf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                    vid: vid,
                });
                return [2 /*return*/, this.networkRequestService.instance.get(url)];
            });
        });
    };
    AccountRepository.prototype.unbindUserInfo = function (unbindType) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams({
                    type: unbindType,
                    xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                });
                return [2 /*return*/, this.networkRequestService.instance.post(ACCOUNT_USER_UNBIND, formData)];
            });
        });
    };
    AccountRepository.prototype.bindUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams({
                    bindType: ACCOUNT_TYPE.QQ,
                    p_luin: getCookie('p_luin'),
                    p_uin: getCookie('p_uin'),
                    p_skey: getCookie('p_skey'),
                    p_lskey: getCookie('p_lskey'),
                    xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                });
                return [2 /*return*/, this.networkRequestService.instance.post(ACCOUNT_USER_BIND, formData)];
            });
        });
    };
    AccountRepository.prototype.CurrentLoginAccountBindInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.networkRequestService.instance.get(LOGIN_ACCOUNT_INFO)];
            });
        });
    };
    // shouldAddUFlag 兜底逻辑，后台就绪后可删除此参数。目前为了兼容某些极端case需要添加 uflag = qqsig 参数
    AccountRepository.prototype.BindingAccountInfo = function () {
        return __awaiter(this, arguments, void 0, function (shouldAddUFlag) {
            var urlParams, url;
            if (shouldAddUFlag === void 0) { shouldAddUFlag = false; }
            return __generator(this, function (_a) {
                urlParams = __assign({}, (shouldAddUFlag ? { uflag: 'qqsig' } : null));
                url = addURLParameters(BINDING_QQ_ACCOUNT_INFO, urlParams);
                return [2 /*return*/, this.networkRequestService.instance.get(url)];
            });
        });
    };
    AccountRepository.prototype.getBindWxQrCode = function (u) {
        var url = "".concat(WXQRCODE, "?xsrf=").concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf), "&page=").concat(encodeURIComponent('pages/bindwx/bindwx'), "&ac=bind&ts=").concat(Date.now(), "&u=").concat(u, "&checkKey=1");
        return this.networkRequestService.instance.get(url);
    };
    AccountRepository.prototype.getBindProcess = function (checkKey) {
        var url = "".concat(POLLING, "?CheckKey=").concat(checkKey);
        return this.networkRequestService.instance.post(url);
    };
    AccountRepository.prototype.getPersonalUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cookieXsrf, url;
            return __generator(this, function (_a) {
                cookieXsrf = getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf);
                url = "".concat(USER_INFO_CGI, "?xsrf=").concat(cookieXsrf, "&get_vip_info=1");
                return [2 /*return*/, this.networkRequestService.instance.get(url)];
            });
        });
    };
    AccountRepository.prototype.getCertificationGrey = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.networkRequestService.instance.get(USER_CERTIFICATION_CHECK)];
            });
        });
    };
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], AccountRepository.prototype, "logout", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], AccountRepository.prototype, "wecomLogoutForBDomain", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], AccountRepository.prototype, "wecomLogoutForCDomain", null);
    __decorate([
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", Promise)
    ], AccountRepository.prototype, "unbindUserInfo", null);
    __decorate([
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], AccountRepository.prototype, "bindUserInfo", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], AccountRepository.prototype, "CurrentLoginAccountBindInfo", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], AccountRepository.prototype, "BindingAccountInfo", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], AccountRepository.prototype, "getBindWxQrCode", null);
    __decorate([
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], AccountRepository.prototype, "getBindProcess", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], AccountRepository.prototype, "getPersonalUserInfo", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], AccountRepository.prototype, "getCertificationGrey", null);
    AccountRepository = __decorate([
        __param(0, INetworkRequestService),
        __metadata("design:paramtypes", [Object])
    ], AccountRepository);
    return AccountRepository;
}());
export { AccountRepository };
